import { render, staticRenderFns } from "./createInfo.vue?vue&type=template&id=760064f5&scoped=true"
import script from "./createInfo.vue?vue&type=script&lang=js"
export * from "./createInfo.vue?vue&type=script&lang=js"
import style0 from "./createInfo.vue?vue&type=style&index=0&id=760064f5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760064f5",
  null
  
)

export default component.exports